import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpansionJoint = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 20,
	viewBox: "0 0 50.0 20.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 6.0 L 7.0 6.0 A 4.5 4.5 0.0 0 1 16.0 6.0 A 4.5 4.5 0.0 0 1 25.0 6.0 A 4.5 4.5 0.0 0 1 34.0 6.0 A 4.5 4.5 0.0 0 1 43.0 6.0 L 50.0 6.0 L 50.0 14.0 L 43.0 14.0 A 4.5 4.5 0.0 0 1 34.0 14.0 A 4.5 4.5 0.0 0 1 25.0 14.0 A 4.5 4.5 0.0 0 1 16.0 14.0 A 4.5 4.5 0.0 0 1 7.0 14.0 L 0.0 14.0 Z Z M 50.0 0.0 L 50.0 20.0 M 0.0 0.0 L 0.0 20.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgExpansionJoint;
